/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FileSizeLimits_organization$ref: FragmentReference;
declare export opaque type FileSizeLimits_organization$fragmentType: FileSizeLimits_organization$ref;
export type FileSizeLimits_organization = {|
  +id: string,
  +configuration: ?any,
  +$refType: FileSizeLimits_organization$ref,
|};
export type FileSizeLimits_organization$data = FileSizeLimits_organization;
export type FileSizeLimits_organization$key = {
  +$data?: FileSizeLimits_organization$data,
  +$fragmentRefs: FileSizeLimits_organization$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FileSizeLimits_organization",
  "type": "OrganizationNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "configuration",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a908bb72d6494d38ce978cf33224c18f';
module.exports = node;
